/**
 * 付款凭证 预览
 *
 * Author:   fjj
 * 参考我的订单中-支付定金 逻辑
 * 来源 \PayDeposit\index.js
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/11/30      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import PropTypes from "prop-types";
import React from "react";
import {Button,Modal,message} from 'antd';
import Lang from "@components/Lang/Lang"
import { postHttpAction } from '@utils/utils';
import { numberWithCommas, toFixedWithCommas} from "@utils/number-util";
import dayjs from "dayjs";
import "./index.less";
class PayDeposit extends React.Component{
    static propTypes = {
        record:PropTypes.object,
        handleOk:PropTypes.func
    }
    static defaultProps = {
        //暂存柜id
        record: {},
        //支付完毕后的回调
        handleOk:function () {

        }
    }
    constructor(props) {
        super(props);
        this.state = {
            //是否展示弹窗
            visible: false,
            //数据源
            list:[],
            model:{},
            //DDP应收明细Id
            ids:[],
            payType: '', // 'DEPOSIT':订金, 'GOODS_COST_TOW',尾款
            extra:{}, //
        }
    }
    /**
     * 取消
     * @param e
     */
    handleCancel = e => {
        this.setState({
            //是否展示弹窗
            visible: false,
            //数据源
            list:[],
            model:{},
            //DDP应收明细Id
            ids:[],
            payType: '', // 'DEPOSIT':订金, 'GOODS_COST_TOW',尾款
            extra:{}, //
        });
    };
    /**
     * 提示
     **/
    getTip(){
        let list = this.state.list||[];
        let num = 0;
        list.map(function (item) {
            (item.itemList||[]).map(function (po) {
                if(po.receivableItemStatus=='TO_BE_CONFIRM'){
                    num++;
                }
            });
        })
        return __getServerLanguage('BenDingDanDe3GeZiDingDanYiDaoHuo',num);//当前有{0}个订单待支付，请于提货前支付。
    }
    /**
     * 查看付款凭证
     **/
    toViewPayment = async (record={})=>{
        if(record.type =='DEPOSIT'){ //订金
          if(record.invoiceFileUrl){
              window.open(record.invoiceFileUrl);
          }else {
              message.warning(Lang({id: 'ZanWuShuJu', default: '暂无数据'}));
              return false;
          }
        //     const postUrl = '/data/mc/r/po/query-pay-deposit-list';
        //     const postData = {
        //         containerId : record.containerId,
        //     };
        //     const res = await postHttpAction(postUrl,postData);
        //     if(res.success&&res.valid){
        //         if(res.model&&res.model.needDepositMoneyTotal>0){
        //             let list = res.models||[];
        //             let ids = [];
        //             for(var i = 0;i<list.length;i++){
        //                 ids.push(list[i].id);
        //             }
        //             this.setState({
        //                 ids:ids,
        //                 list:res.models||[],
        //                 model:res.model||{},
        //                 visible: true,
        //                 payType:record.type,
        //             })
        //         }
        //     }
        }else if( record.type=='GOODS_COST_TOW'){ //尾款
            const postUrl = '/mg/po/essa-one/pay-balance-list';
            const postData = {
                buyerId : record.buyerId,
                conContainerId : record.fromBizId,
            };
            postHttpAction(postUrl,postData, (res) => {
                const list = res.models||[];
                let ids = [];
                let totalPrice = 0;
                // let checkboxList = [];
                //如果是在详情页里支付尾款的,或者列表也只有一个柜需要支付尾款
                if(list.length==1){
                    for(let i = 0;i<list.length;i++){
                        // checkboxList.push(list[i].containerId);
                        for(let j =0;j<list[i].itemList.length;j++){
                            let item = list[i].itemList[j];
                            ids.push(item.receivableItemId);
                            totalPrice+=item.balance;
                        }
                    }
                }
                this.setState({
                    // checkboxList:checkboxList,
                    ids:ids,
                    totalPrice:totalPrice,
                    list:list,
                    model:list.length>0?list[0]:{}, //设置查看凭证数据
                    extra:res.extra||{},
                    visible: true,
                    payType:record.type,
                });
            });

        }
    }
    componentDidMount(){
    }

    render(){
        const { record } = this.props;
        const { visible,model,list,payType,extra,ids } = this.state;
        let footer = [
            <Button key="back" onClick={this.handleCancel}>
                {Lang({id: 'QuXiao', default: '取消'})}
            </Button>
        ];
        if(model&&model.invoiceFileUrl)footer.push(<Button target={'_blank'} href={model.invoiceFileUrl}
                                                           type={"primary"}>
            {Lang({id: 'ChaKanFuKuanPingZheng', default: '查看付款凭证'})}
        </Button>)
        return (
            <span>
                {/*订金*/}
                {visible&&payType=='DEPOSIT'&&<Modal
                    title={Lang({id: 'FuKuanPingZheng', default: '付款凭证'})}
                    open={visible}
                    width={850}
                    centered={true}
                    getContainer={false}
                    wrapClassName="pay-final"
                    onCancel={this.handleCancel}
                    footer={footer}
                >
                    <div className="pay-final-wrap">
                        {
                            model.isSplit==1?
                                <div className="title">
                                    {Lang({id: 'BenDingDanBaoHanNGeZiDingDanDingJin', default: '本订单包含{0}个子订单，定金不可分开支付',params:[list.length||0]})}
                                </div>:
                                null
                        }
                        <div className="pay-list-wrap">
                            <ul>
                                {
                                    list.map(function (item,index) {
                                        return <li key={index}>
                                            <div>
                                                <p>{model.isSplit==1?Lang({id: 'ZiDingDan', default: '子订单'}):Lang({id: 'DingDan', default: '订单'})} {item.code}</p>
                                                <p className="num">
                                                    <b>{Lang({id: 'DingJin', default: '定金'})}：{numberWithCommas(toFixedWithCommas(item.needDepositMoney,2))} {model.currencySymbol}</b>
                                                </p>
                                            </div>
                                            {/*<Button shape="round" href={`/member/po-detail/${item.id}`} size="small">{__getServerLanguage('ChaKan')}</Button>*/}
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                        <div className="total-wrap">
                            <p className="name">
                                <span>{Lang({id: 'HeJiDaiZhiFu', default: '合计待支付'})}：</span>
                                <b className="num">{numberWithCommas(toFixedWithCommas(model.needDepositMoneyTotal,2))} {model.currencySymbol}</b>
                            </p>
                        </div>
                    </div>
                </Modal>}
                {/*尾款*/}
                {visible&&payType=='GOODS_COST_TOW'&&<Modal
                    title={__getServerLanguage('FuKuanPingZheng')}
                    open={visible}
                    width={850}
                    centered={true}
                    getContainer={false}
                    wrapClassName="pay-final"
                    onCancel={this.handleCancel}
                    footer={footer}
                >
                    <div className="pay-final-wrap">
                        {
                            (record.containerId||record.poId)?
                                null
                                :
                                <div className="explain">
                                    <i className="iconfont icon-xinxix margin-right-5"></i>
                                    <span>{this.getTip()}</span>
                                </div>
                        }
                        <div className="pay-list-wrap">
                            {
                                list.map(function (model,index) {
                                    if(extra.type=='FULL_GOODS_COST'||model.type=='FULL_GOODS_COST'){
                                        return <div key={index}>
                                            <div className="title mt_8">
                                                <span className="margin-left-10">
                                                       {Lang({id:'QuanKuanHeJiN', default: '全款合计'})} {numberWithCommas(toFixedWithCommas(model.balance,2))} {extra.currencySymbol}
                                                    </span>
                                            </div>
                                            <div>
                                                <ul>
                                                    {
                                                        model.itemList.map(function (item,i) {
                                                            return <li key={i}>
                                                                <div>
                                                                    <p>{item.isSplit==1?Lang({id:'ZiDingDan', default: '子订单'}):Lang({id:'DingDan', default: '订单'})} {item.poCode}  &nbsp; {__getServerLanguage('XiaDanShiJian')}：{dayjs(item.createTime).format('YYYY-MM-DD')}</p>
                                                                    <p className="num"><b>{Lang({id:'QuanKuan', default: '全款'})}：{numberWithCommas(toFixedWithCommas(item.balance,2))||'-'} {item.currencySymbol}</b></p>
                                                                </div>
                                                                {/*<Button shape="round" size="small" href={`/member/po-detail/${item.poId}`}>{__getServerLanguage('ChaKan')}</Button>*/}
                                                            </li>
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    }else{
                                        return <div key={index}>
                                            <div className="title mt_8">
                                                <span className="margin-left-10" dangerouslySetInnerHTML={{__html: Lang({id:'YiXiaDingDanYuJiDaoGang',
                                                        default: '以下订单预计<i>{0}</i>到港，合计尾款：{1}',
                                                    params: [dayjs(model.arrivalPortDate).format('YYYY-MM-DD'),`${numberWithCommas(toFixedWithCommas(model.balance,2))} ${extra.currencySymbol}`]})}}>
                                                    </span>
                                            </div>
                                            <div>
                                                <ul>
                                                    {
                                                        model.itemList.map(function (item,i) {
                                                            return <li key={i}>
                                                                <div>
                                                                    <div>{item.isSplit==1?Lang({id:'ZiDingDan', default: '子订单'}):Lang({id:'DingDan', default: '订单'})} {item.poCode}  &nbsp; {__getServerLanguage('XiaDanShiJian')}：{dayjs(item.createTime).format('YYYY-MM-DD')}</div>
                                                                    <div className="num">
                                                                        <b>{Lang({id:'WeiKuan', default: '尾款'})}：{numberWithCommas(toFixedWithCommas(item.balance,2))||'-'} {item.currencySymbol}</b>
                                                                        {item.receivableItemStatus=='TO_BE_CONFIRM'?<span className={"ml_8 font_14 color-yellow"}>{Lang({id:'DaiFuKuan', default: '待支付'})}</span>:null}
                                                                        {item.receivableItemStatus=='CONFIRMED'?<span className={"ml_8 font_14 color-green2"}>{Lang({id:'YiZhiFu', default: '已支付'})}</span>:null}
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    {item.invoiceFileUrl?<Button shape="round" size="small"
                                                                                                 target={'_blank'}
                                                                                                 type={"primary"}
                                                                                                 href={item.invoiceFileUrl} className="mr_4">
                                                                        {Lang({id: 'FuKuanPingZheng', default: '付款凭证'})}
                                                                        </Button>:null}
                                                                    {/*<Button shape="round" size="small" href={`/member/po-detail/${item.poId}`}>{__getServerLanguage('ChaKan')}</Button>*/}
                                                                </div>
                                                            </li>
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    }

                                })
                            }
                        </div>
                        <div className="total-wrap">
                            {
                                record.poId&&ids.length>0?
                                    <p className="name">
                                        <span>{Lang({id: 'BenCiZhiFuHeJi', default: '本次支付合计'})}：</span>
                                        <b className="num">{numberWithCommas(toFixedWithCommas(this.state.totalPrice,2))||'-'} {extra.currencySymbol}</b>
                                    </p>:
                                    <p className="name">
                                        <span>{Lang({id: 'HeJiDaiZhiFu', default: '合计待支付'})}：</span>
                                        <b className="num">{numberWithCommas(toFixedWithCommas(extra.totalPayPrice,2))||'-'} {extra.currencySymbol}</b>
                                    </p>
                            }
                        </div>
                    </div>
                </Modal>}
                    <Button className="to-veiw-payment-btn"
                            onClick={()=>this.toViewPayment(record)}>
                          {Lang({id: 'ChaKanFuKuanPingZheng', default: '查看付款凭证'})}
                    </Button>
            </span>
        )
    }
}
export default PayDeposit;
